import { useState } from "react";
import "./month_wise_review_ivf.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  fetchPatientDetailsUuid,
  coupleIdChecker,
  postAppointment,
} from "../../Redux/Thunk/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../../assets/images/ascas.svg";
import Headers from "../../Components/Header/Headers";
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter";
export default function MonthWiseReview(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector((state) => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
    });

  const [patientOne_UUId, setPatientOne_UUId] = useState("");

  const handleChange = (e) => {
    // const { name, value } = e.target;
    // setFormData({ ...formData, [name]: value });
    var text = e.target.value;

    if (e.target.name === "patientId1") {
      if (e.target.value.length === 10 && e.target.value.charAt(0) === "A") {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          };
          props.loaderchange("true");
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat =
              data?.titles + " " + data?.first_name + " " + data?.last_name;
            if (e.target.name === "patientId1") {
              setPatientOne_UUId(data?.id);
              setFormData({
                ...formData,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text,
              });
            }
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === "patientId1") {
          setFormData({
            ...formData,
            patientId1: e.target.value,
          });
        }
      }
    } else {
      console.log("Going in");
      setFormData({ ...formData, [e.target.name]: e.target.value });
      if (e.target.name === "nextappointment") {
        const dateTime = e.target.value.split("T");
        setAppointmentData({
        ...appointmentData,
        date: dateTime[0],
        time: dateTime[1],
        p_uhid: props.patientsData.p_uhid,
        name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
        status: "Not Visited",
        notes: "Booking Visit",
        patient_id: patientId,
        });
        }
    }
  };
  const renderDiscPoint = () => (
    <span
      style={{
        fontSize: "30px",
        // lineHeight: "20px",
        display: "flex",
        alignItems: "center",
        height: "20px",
      }}
    >
      ●
    </span>
  );
  const renderIndentation = () => (
    <span
      style={{
        visibility: "hidden",
        fontSize: "30px",
        lineHeight: "20px",
      }}
    >
      ●
    </span>
  );
  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value, options = {}) => {
    const { style = { border: "1px solid black", textAlign: "center" } } =
      options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const {
      style = { border: "1px solid black", textAlign: "center" },
      colspans = 1,
    } = options;
    return (
      <th colSpan={colspans} style={style}>
        {value}
      </th>
    );
  };

  const handlesubmit = () => {
    props.loaderchange("true");
    try {
      if (
        props.patientsData.id !== "" &&
        props.patientsData.p_uhid !== "" &&
        props.patientsData.p_uhid.length === 10
      ) {
        setshow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById(
            "prescriptionReportWrap"
          ).innerHTML;

          // Prepare payload for creating report
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "Month Wise Review Ivf",
            },
          };

          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
            };
            createNewAppointment();
          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate("/PatientView");
            Swal.fire({
              title: "Successful.",
              text: "Record added successful.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  return (
    <>
      <div id="MonthWiseReview">
        <div className="MonthWiseReview">
          <div
            className=""
            style={{ width: "100%", display: "block" }}
            id="patientInfo1"
          >
            <div style={{ width: "100%" }}>
              <img
                className="header_image"
                src={headerimage}
                style={{
                  // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                  width: "100%",
                  margin: "0 auto",
                }}
              ></img>
            </div>
            {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap:"3px"

            }}
          > */}
            {/* Patient ID and Couple ID (Side by side) */}
            {/* <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={formData.patientId1}
                  onChange={(e) => handleChange(e)}
                  name="patientId1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.patientId1}
                </span>
              </div>
            </div> */}

            {/* Patient Name */}
            {/* <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={formData.patientName1}
                name="patientName1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;{formData.patientName1}
              </span>
            </div> */}
            {/* Gender and Blood Group (Side by side) */}
            {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={formData.gender1}
                  name="gender1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value="" disabled selected>
                    Select Gender
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.gender1}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={formData.age1}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.age1}
              </span>
            </div> */}

            {/* <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center",
                // paddingLeft: "25px",
              }}
            >
              <span style={{ fontWeight: 600 }}>Blood Group</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                name="bloodGroup1"
                value={formData.bloodGroup1}
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  backgroundColor: "white",
                }}
              >
                <option value="" disabled selected>
                  Select Blood Group
                </option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bloodGroup1}
              </span>
            </div> */}
            {/* </div> */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                gap: "3px",
                backgroundColor: "#f7f7f7 ",
                borderRadius: "6px",
                padding: "16px 8px 16px 8px",
                gap: "3px",
              }}
            >
              <div
                style={{ display: "flex", gap: "16px", alignItems: "center" }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "125px 16px 250px",
                    alignItems: "center ",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Patient ID</span>
                  <span style={{ fontWeight: 600 }}>: </span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    value={props.patientsData.p_uhid}
                    onChange={(e) => handleChange(e)}
                    name="patientId"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{props.patientsData.p_uhid}
                  </span>
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient Name</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                  name="patientName"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    color: "#000",
                  }}
                />
                <span
                  className={`input ${!show ? "hide" : "show"}`}
                  style={{ width: "100%" }}
                >
                  &nbsp;
                  {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "125px 16px 250px",
                    alignItems: "center ",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Gender</span>
                  <span style={{ fontWeight: 600 }}>: </span>
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    value={props.patientsData.gender}
                    name="gender"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      backgroundColor: "white",
                    }}
                  >
                    <option value={props.patientsData.gender} selected>
                      {props.patientsData.gender}
                    </option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Others">Others</option>
                    <option value="Decline to State">Decline to State</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{props.patientsData.gender}
                  </span>
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Age</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={props.patientsData.age}
                  name="age1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.age}
                </span>
              </div>
            </div>
          </div>
          <div className="detail">
            <h3>
              1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4<sup>TH</sup> MONTH REVIEW
            </h3>
            <p>
              Obstetric score:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="obstetricScore"
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.obstetricScore}
              </span>
              POG:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="pog"
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pog}
              </span>
            </p>
            <p>
              Complaints:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="complaints"
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.complaints}
              </span>
            </p>
            <p>
              Double marker report:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="doubleMarkerReport"
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.doubleMarkerReport}
              </span>
            </p>
            <p>
              Blood reports:
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                name="bloodReports"
                style={{ border: "1px solid gray", borderRadius: "3px" }}
                onChange={handleChange}
              >
                <option disabled selected>
                  Select
                </option>
                <option value="Entered">Entered</option>
                <option value="Not Entered">Not entered</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bloodReports}
              </span>
            </p>
            <p>
              O/E: Pallor:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="pallor"
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pallor}
              </span>
              Pedal Edema:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="pedalEdema"
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pedalEdema}
              </span>
            </p>
            <p>
              PR:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="pr"
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pr}
              </span>
              BP:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="bp"
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bp}
              </span>
              Weight:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="weight"
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.weight}
              </span>
              KG&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Prev visit weight:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="prevVisitWeight"
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.prevVisitWeight}
              </span>
            </p>
            <p>P/A: Uterus 16weeks, relaxed, liquor average, FHS good</p>
            <p>
              Cervical length:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="cervicalLength"
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.cervicalLength}
              </span>
            </p>
            <p>Adv: Inj TD vac im stat/Option of Given 27-36 weeks</p>
          </div>
          <table className="table_1" border="1px" cellSpacing="0px">
            <tbody>
              <tr>
                <th> S.No</th>
                <th> DRUG</th>
                <th> DOSAGE</th>
                <th> FREQUENCY</th>
                <th> TIME TO TAKE</th>
                <th> DAYS</th>
              </tr>
              {[
                {
                  sno: 1,
                  name: "T.TRITOFER XT/ FURNEXT/GLOBAC XT (Iron supplement)",
                },
                { sno: 2, name: "C.FOLIVISTA (Folic acid supplement)" },
                { sno: 3, name: "T.VEHYCAL (Calcium+VitD3)" },
                { sno: 4, name: "INJ.Td VAC" },
                { sno: 5, name: "VIVA MOM" },
                {
                  sno: 6,
                  name: "SYP.GAVISCON (Sodium Alginate+Sodium Bicarbonate Calcium Carbonate)",
                },
                { sno: 7, name: "BIO OIL" },
                { sno: 8, name: "TAB. THYRONORM (Levothyroxine)" },
                { sno: 9, name: "TAB.GLYCOMET SR" },
              ].map((drug, index) => (
                <tr key={index}>
                  <td>{drug.sno}</td>
                  <td>
                    {drug.name.split("\n").map((line, idx) => (
                      <div key={idx}>
                        {line}
                        <br />
                      </div>
                    ))}
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`dosage${drug.sno}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`dosage${drug.sno}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`frequency${drug.sno}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`frequency${drug.sno}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`timeToTake${drug.sno}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`timeToTake${drug.sno}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`days${drug.sno}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`days${drug.sno}`]}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <br />
          <br />
          <div className="bulletin">
            <ul>
              <li>
                NEXT REVIEW:{" "}
                <input
                  type="date"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="nextReview"
                  value={formData.nextReview}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.nextReview}
                </span>
              </li>
              <li>
                INVESTIGATIONS: ANOMALY SCAN + FETAL ECHO ON{" "}
                <input
                  type="date"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="INVESTIGATIONS"
                  value={formData.INVESTIGATIONS}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.INVESTIGATIONS}
                </span>
              </li>
              <li>Blood tests:  <input
                  type="text"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="bloodTests"
                  value={formData.bloodTests}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.bloodTests}
                </span></li>
              <li>PICME NUMBER to be registered</li>
            </ul>
          </div>
          <br />
          <br />
          <div className="detail">
            <h3>
              2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5<sup>TH</sup> MONTH
            </h3>
            <p>
              Obstetric score:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="obstetricScore1"
                value={formData.obstetricScore1}
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.obstetricScore1}
              </span>
              POG:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="pog1"
                value={formData.pog1}
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pog1}
              </span>
            </p>
            <p>
              Complaints:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="complaints1"
                value={formData.complaints1}
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.complaints1}
              </span>
            </p>
            <p>
              Double marker report:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="doubleMarkerReport1"
                value={formData.doubleMarkerReport1}
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.doubleMarkerReport1}
              </span>
            </p>
            {/* Continue this pattern for each input */}
            {/* Example for Blood reports */}
            <p>
              Blood reports:
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                name="bloodReports1"
                style={{ border: "1px solid gray", borderRadius: "3px" }}
                onChange={handleChange}
              >
                <option disabled selected>
                  Select
                </option>
                <option value="Entered">Entered</option>
                <option value="Not Entered">Not entered</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bloodReports1}
              </span>
            </p>
            <p>
              O/E: Pallor:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="pallor1"
                value={formData.pallor1}
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pallor1}
              </span>
              Pedal Edema:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="pedalEdema1"
                value={formData.pedalEdema1}
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pedalEdema1}
              </span>
            </p>
            {/* Example for PR, BP, Wt, and Prev visit weight */}
            <p>
              PR:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="pr1"
                value={formData.pr1}
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pr1}
              </span>
              BP:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="bp1"
                value={formData.bp1}
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bp1}
              </span>
              Weight:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="weight1"
                value={formData.weight1}
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.weight1}
              </span>
              KG&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Prev visit weight:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="prevVisitWeight1"
                value={formData.prevVisitWeight1}
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.prevVisitWeight1}
              </span>
            </p>
            {/* Continue with remaining inputs */}
            {/* Example for Scan Report and Fetal Echo */}
            <p>
              Scan Report:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="scanReport1"
                value={formData.scanReport1}
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.scanReport1}
              </span>
            </p>
            <p>
              Fetal Echo:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="fetalEcho1"
                value={formData.fetalEcho1}
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.fetalEcho1}
              </span>
            </p>
            {/* Example for Tests */}
            <p>
              Tests: HB-
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="hb1"
                value={formData.hb1}
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.hb1}
              </span>
              g/dl, GTT-
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="gtt1"
                value={formData.gtt1}
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.gtt1}
              </span>
              TSH-
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="tsh1"
                value={formData.tsh1}
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.tsh1}
              </span>
              URINE C/S:
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="urineCS1"
                value={formData.urineCS1}
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.urineCS1}
              </span>
            </p>
          </div>
          <br />
          <table className="table_1" border="1px" cellSpacing="0px">
            <tbody>
              <tr>
                <th> S.No</th>
                <th> DRUG</th>
                <th> DOSAGE</th>
                <th> FREQUENCY</th>
                <th> TIME TO TAKE</th>
                <th> DAYS</th>
              </tr>
              {[
                {
                  sno: 1,
                  name: "T. TRITOFER XT/\nFURNEXT/GLOBAC XT\n(Iron supplement)",
                },
                { sno: 2, name: "T. VEHYCAL XT\n(Calcium supplement)" },
                {
                  sno: 3,
                  name: "C. FOLVISTA/TRAFOLIC/FOLINEXT GOLD\n(Folic acid supplement)",
                },
                {
                  sno: 4,
                  name: "VIVA MOM\n(optional)\n2tsp-0-2tsp\nWITH MILK",
                },
                { sno: 5, name: "C. GESTOBOND\n(Vaginal progesterone)" },
                { sno: 6, name: "T. DYDROFIRST/DYDROBOON\n(Dydrogesterone)" },
                { sno: 7, name: "SILKY WASH" },
                {
                  sno: 8,
                  name: "CANDID CL PESSARY\n(Clindamycin+Clotrimazole)",
                },
                { sno: 9, name: "T. ECOSPIRIN\n(Aspirin)" },
                {
                  sno: 10,
                  name: "T. GLYCOMET SR\n(Metformin sustained release)",
                },
                { sno: 11, name: "LUCIARA CREAM" },
                { sno: 12, name: "T. THYRONORM" },
              ].map((drug, index) => (
                <tr key={index}>
                  <td>{drug.sno}</td>
                  <td>
                    {drug.name.split("\n").map((line, idx) => (
                      <div key={idx}>
                        {line}
                        <br />
                      </div>
                    ))}
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`dosage${drug.sno + "1"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`dosage${drug.sno + "1"}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`frequency${drug.sno + "1"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`frequency${drug.sno + "1"}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`timeToTake${drug.sno + "1"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`timeToTake${drug.sno + "1"}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`days${drug.sno + "1"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`days${drug.sno + "1"}`]}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <br />
          <br />
          <div className="bulletin">
            <ul>
              <li>
                NEXT REVIEW:{" "}
                <input
                  type="date"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="nextReview1"
                  value={formData.nextReview1}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.nextReview1}
                </span>
              </li>
              <li>
                INVESTIGATIONS:{" "}
                <input
                  type="date"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="INVESTIGATIONS1"
                  value={formData.INVESTIGATIONS1}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.INVESTIGATIONS1}
                </span>
              </li>
              <li>
                Blood tests:{" "}
                <input
                  type="text"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="Bloodtests1"
                  value={formData.Bloodtests1}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.Bloodtests1}
                </span>
              </li>
              <li>PICME NUMBER to be registered</li>
              <li>
                Fetal movements to be felt.You should feel regular perception of
                fetal movements.
              </li>
            </ul>
          </div>
          <br />
          <br />
          <div className="detail">
            <h3>
              3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6<sup>TH</sup> MONTH
              SPONTANEOUS
            </h3>
            <p>
              Obstetric score:{" "}
              <input
                className={`input_2 ${show ? "hide" : "show"}`}
                name="obstetricScore2"
                onChange={handleChange}
                value={formData.obstetricScore2}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.obstetricScore2}
              </span>
              POG:{" "}
              <input
                className={`input_2 ${show ? "hide" : "show"}`}
                name="pog2"
                onChange={handleChange}
                value={formData.pog2}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pog2}
              </span>
            </p>
            <p>
              Complaints:{" "}
              <input
                className={`input_2 ${show ? "hide" : "show"}`}
                name="complaints2"
                onChange={handleChange}
                value={formData.complaints2}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.complaints2}
              </span>
            </p>
            <p>
              Blood reports:{" "}
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                style={{ border: "1px solid gray", borderRadius: "3px" }}
                name="bloodReports2"
                onChange={handleChange}
              >
                <option disabled selected>
                  Select
                </option>
                <option value="Entered">Entered</option>
                <option value="Not Entered">Not entered</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bloodReports2}
              </span>
            </p>
            <p>
              O/E: Pallor:{" "}
              <input
                className={`input_2 ${show ? "hide" : "show"}`}
                name="pallor2"
                onChange={handleChange}
                value={formData.pallor2}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pallor2}
              </span>
              Pedal Edema:{" "}
              <input
                className={`input_2 ${show ? "hide" : "show"}`}
                name="pedalEdema2"
                onChange={handleChange}
                value={formData.pedalEdema2}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pedalEdema2}
              </span>{" "}
            </p>
            <p>
              PR:{" "}
              <input
                className={`input_2 ${show ? "hide" : "show"}`}
                name="pr2"
                onChange={handleChange}
                value={formData.pr2}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pr2}
              </span>{" "}
              BP:{" "}
              <input
                className={`input_2 ${show ? "hide" : "show"}`}
                name="bp2"
                onChange={handleChange}
                value={formData.bp2}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bp2}{" "}
              </span>
              Weight:{" "}
              <input
                className={`input_2 ${show ? "hide" : "show"}`}
                name="weight2"
                onChange={handleChange}
                value={formData.weight2}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.weight2}{" "}
              </span>{" "}
              KG&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Prev visit weight:{" "}
              <input
                className={`input_2 ${show ? "hide" : "show"}`}
                name="prevVisitWeight2"
                onChange={handleChange}
                value={formData.prevVisitWeight2}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.prevVisitWeight2}{" "}
              </span>{" "}
            </p>
            <p>P/A: Uterus 24 weeks, relaxed, liquor average, FHS good</p>
          </div>
          <br />
          <table className="table_1" border="1px" cellSpacing="0px">
            <tbody>
              <tr>
                <th> S.No</th>
                <th> DRUG</th>
                <th> DOSAGE</th>
                <th> FREQUENCY</th>
                <th> TIME TO TAKE</th>
                <th> DAYS</th>
              </tr>
              {[
                {
                  sno: 1,
                  name: "T. TRITOFER XT/\nFURNEXT/GLOBAC XT\n(Iron supplement)",
                },
                { sno: 2, name: "T. VEHYCAL XT\n(Calcium supplement)" },
                {
                  sno: 3,
                  name: "C. FOLVISTA/TRAFOLIC/FOLINEXT GOLD\n(Folic acid supplement)",
                },
                {
                  sno: 4,
                  name: "VIVA MOM\n(optional)\n2tsp-0-2tsp\nWITH MILK",
                },
                { sno: 5, name: "C. GESTOBOND\n(Vaginal progesterone)" },
                { sno: 8, name: "T. DYDROFIRST/DYDROBOON\n(Dydrogesterone)" },
                { sno: 10, name: "SILKY WASH" },
                {
                  sno: 11,
                  name: "CANDID CL PESSARY\n(Clindamycin+Clotrimazole)",
                },
                { sno: 12, name: "T. ECOSPIRIN\n(Aspirin)" },
                {
                  sno: 13,
                  name: "T. GLYCOMET SR\n(Metformin sustained release)",
                },
                { sno: 14, name: "LUCIARA CREAM" },
                { sno: 15, name: "T. THYRONORM" },
              ].map((drug, index) => (
                <tr key={index}>
                  <td>{drug.sno}</td>
                  <td>
                    {drug.name.split("\n").map((line, idx) => (
                      <div key={idx}>
                        {line}
                        <br />
                      </div>
                    ))}
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`dosage${drug.sno + "2"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`dosage${drug.sno + "2"}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`frequency${drug.sno + "2"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`frequency${drug.sno + "2"}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`timeToTake${drug.sno + "2"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`timeToTake${drug.sno + "2"}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`days${drug.sno + "2"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`days${drug.sno + "2"}`]}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <br />
          <br />
          <div className="bulletin">
            <ul>
              <li>
                NEXT REVIEW:{" "}
                <input
                  type="date"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="nextReview2"
                  value={formData.nextReview2}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.nextReview2}
                </span>
              </li>
              <li>

                INVESTIGATIONS: SCAN -GROWTH+LIQUOR -{" "}
                <input
                  type="date"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="INVESTIGATIONS2"
                  value={formData.INVESTIGATIONS2}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.INVESTIGATIONS2}
                </span>{" "}
              </li>
              <li>Blood tests:
              <input
                  type="text"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="bloodTests2"
                  value={formData.bloodTests2}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.bloodTests2}
                </span>
              </li>
              <li>PICME NUMBER to be registered</li>
              <li>
                Fetal movements to be felt.You should feel regular perception of
                fetal movements.if fetal movements are less,lie to one side,eat
                something and then feel
              </li>
            </ul>
          </div>
          <br />
          <br />
          <div className="detail">
            <h3>
              4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7<sup>TH</sup> MONTH
            </h3>
            <p>
              Obstetric score:{" "}
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="obstetricScore3"
                onChange={handleChange}
                value={formData.obstetricScore3}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.obstetricScore3}
              </span>
              POG:{" "}
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="pog3"
                onChange={handleChange}
                value={formData.pog3}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pog3}
              </span>
            </p>
            <p>
              Complaints:{" "}
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="complaint3"
                onChange={handleChange}
                value={formData.complaint3}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.complaints3}
              </span>
            </p>
            <p>
              Blood reports:{" "}
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                style={{ border: "1px solid gray", borderRadius: "3px" }}
                name="bloodReports3"
                onChange={handleChange}
              >
                <option disabled selected>
                  Select
                </option>
                <option value="Entered">Entered</option>
                <option value="Not Entered">Not entered</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bloodReports3}
              </span>
            </p>
            <p>
              O/E: Pallor:{" "}
              <input
                className={`input_2 ${show ? "hide" : "show"}`}
                name="pallor3"
                onChange={handleChange}
                value={formData.pallor3}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pallor3}
              </span>
              Pedal Edema:{" "}
              <input
                className={`input_2 ${show ? "hide" : "show"}`}
                name="pedalEdema3"
                onChange={handleChange}
                value={formData.pedalEdema3}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pedalEdema3}
              </span>{" "}
            </p>
            <p>
              PR: <input
                className={`input_2 ${show ? "hide" : "show"}`}
                name="pr3"
                onChange={handleChange}
                value={formData.pr3}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pr3}
              </span>{" "}
              BP: <input
                className={`input_2 ${show ? "hide" : "show"}`}
                name="bp3"
                onChange={handleChange}
                value={formData.bp3}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bp3}
              </span>{" "}
              Weight: <input
                className={`input_2 ${show ? "hide" : "show"}`}
                name="weight3"
                onChange={handleChange}
                value={formData.weight3}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.weight}
              </span>{" "}
              KG&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Prev visit weight:{" "}
              <input
                className={`input_2 ${show ? "hide" : "show"}`}
                name="prevVisitWeight3"
                onChange={handleChange}
                value={formData.prevVisitWeight3}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.prevVisitWeight3}
              </span>{" "}
            </p>
            <p>P/A: Uterus 28-30 weeks, relaxed, liquor average, FHS good</p>
          </div>
          <br />
          <table className="table_1" border="1px" cellSpacing="0px">
            <tbody>
              <tr>
                <th> S.No</th>
                <th> DRUG</th>
                <th> DOSAGE</th>
                <th> FREQUENCY</th>
                <th> TIME TO TAKE</th>
                <th> DAYS</th>
              </tr>
              {[
                {
                  sno: 1,
                  name: "T. TRITOFER XT/\nFURNEXT/GLOBAC XT\n(Iron supplement)",
                },
                { sno: 2, name: "T. VEHYCAL XT\n(Calcium supplement)" },
                {
                  sno: 3,
                  name: "C. FOLVISTA/TRAFOLIC/FOLINEXT GOLD\n(Folic acid supplement)",
                },
                {
                  sno: 4,
                  name: "VIVA MOM\n(optional)\n2tsp-0-2tsp\nWITH MILK",
                },
                { sno: 5, name: "C. GESTOBOND\n(Vaginal progesterone)" },
                { sno: 8, name: "T. DYDROFIRST/DYDROBOON\n(Dydrogesterone)" },
                { sno: 10, name: "SILKY WASH" },
                {
                  sno: 11,
                  name: "CANDID CL PESSARY\n(Clindamycin+Clotrimazole)",
                },
                { sno: 12, name: "T. ECOSPIRIN\n(Aspirin)" },
                {
                  sno: 13,
                  name: "T. GLYCOMET SR\n(Metformin sustained release)",
                },
                { sno: 14, name: "LUCIARA CREAM" },
                { sno: 15, name: "T. THYRONORM" },
              ].map((drug, index) => (
                <tr key={index}>
                  <td>{drug.sno}</td>
                  <td>
                    {drug.name.split("\n").map((line, idx) => (
                      <div key={idx}>
                        {line}
                        <br />
                      </div>
                    ))}
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`dosage${drug.sno + "3"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`dosage${drug.sno + "3"}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`frequency${drug.sno + "3"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`frequency${drug.sno + "3"}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`timeToTake${drug.sno + "3"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`timeToTake${drug.sno + "3"}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`days${drug.sno + "3"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`days${drug.sno + "3"}`]}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <br />
          <br />
          <div className="bulletin">
            <ul>
              <li>
                NEXT REVIEW:{" "}
                <input
                  type="date"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="nextReview3"
                  value={formData.nextReview3}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.nextReview3}
                </span>
              </li>
              <li> INVESTIGATIONS: 
              <input
                  type="date"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="INVESTIGATIONS3"
                  value={formData.INVESTIGATIONS3}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.INVESTIGATIONS3}
                </span>
              </li>
              <li>Blood tests:  <input
                  type="text"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="bloodTests3"
                  value={formData.bloodTests3}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.bloodTests3}
                </span></li>
              <li>PICME NUMBER to be registered</li>
              <li>
                Fetal movements to be felt.You should feel regular perception of
                fetal movements.if fetal movements are less, lie to one side,eat
                something and then feel
              </li>
            </ul>
          </div>
          <br />
          <br />
          <div className="detail">
            <h3>
              5.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8<sup>TH</sup> MONTH
            </h3>
            <p>
              Obstetric score:{" "}
              <input
                className={`input_14 createTime ${show ? "hide" : "show"}`}
                name="obstetricScore4"
                onChange={(e) => handleChange(e, "obstetricScore4")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.obstetricScore4}
              </span>
              POG:{" "}
              <input
                className={`input_24 createTime ${show ? "hide" : "show"}`}
                name="pog4"
                onChange={(e) => handleChange(e, "pog4")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pog4}
              </span>
            </p>
            <p>
              Complaints:{" "}
              <input
                className={`input_34 createTime ${show ? "hide" : "show"}`}
                name="complaints4"
                onChange={(e) => handleChange(e, "complaints4")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.complaints4}
              </span>
            </p>
            <p>
              Blood reports:{" "}
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                style={{ border: "1px solid gray", borderRadius: "3px" }}
                name="bloodReports4"
                onChange={handleChange}
              >
                <option disabled selected>
                  Select
                </option>
                <option value="Entered">Entered</option>
                <option value="Not Entered">Not entered</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bloodReports4}
              </span>
            </p>
            <p>
              O/E: Pallor:{" "}
              <input
                className={`input_44 createTime ${show ? "hide" : "show"}`}
                name="pallor4"
                onChange={(e) => handleChange(e, "pallor4")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pallor4}
              </span>
              Pedal Edema:{" "}
              <input
                className={`input_54 createTime ${show ? "hide" : "show"}`}
                name="pedalEdema4"
                onChange={(e) => handleChange(e, "pedalEdema4")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pedalEdema4}
              </span>
            </p>
            <p>
              PR:{" "}
              <input
                className={`input_64 createTime ${show ? "hide" : "show"}`}
                name="pr4"
                onChange={(e) => handleChange(e, "pr4")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pr4}
              </span>
              BP:{" "}
              <input
                className={`input_74 createTime ${show ? "hide" : "show"}`}
                name="bp4"
                onChange={(e) => handleChange(e, "bp4")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bp4}
              </span>
              Wt:{" "}
              <input
                className={`input_84 createTime ${show ? "hide" : "show"}`}
                name="weight4"
                onChange={(e) => handleChange(e, "weight4")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.weight4}
              </span>
              KG&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Prev visit weight:{" "}
              <input
                className={`input_94 createTime ${show ? "hide" : "show"}`}
                name="prevVisitWeight4"
                onChange={(e) => handleChange(e, "prevVisitWeight4")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.prevVisitWeight4}
              </span>
            </p>
            <p>P/A: Uterus 34 weeks, relaxed, liquor average, FHS good</p>
          </div>
          <br />
          <table className="table_1" border="1px" cellSpacing="0px">
            <tbody>
              <tr>
                <th> S.No</th>
                <th> DRUG</th>
                <th> DOSAGE</th>
                <th> FREQUENCY</th>
                <th> TIME TO TAKE</th>
                <th> DAYS</th>
              </tr>
              {[
                {
                  sno: 1,
                  name: "T. TRITOFER XT/\nFURNEXT/GLOBAC XT\n(Iron supplement)",
                },
                { sno: 2, name: "T. VEHYCAL XT\n(Calcium supplement)" },
                {
                  sno: 3,
                  name: "C. FOLVISTA/TRAFOLIC/FOLINEXT GOLD\n(Folic acid supplement)",
                },
                {
                  sno: 4,
                  name: "VIVA MOM\n(optional)\n2tsp-0-2tsp\nWITH MILK",
                },
                { sno: 5, name: "C. GESTOBOND\n(Vaginal progesterone)" },
                { sno: 6, name: "T. DYDROFIRST/DYDROBOON\n(Dydrogesterone)" },
                { sno: 7, name: "SILKY WASH" },
                {
                  sno: 8,
                  name: "CANDID CL PESSARY\n(Clindamycin+Clotrimazole)",
                },
                { sno: 9, name: "T. ECOSPIRIN\n(Aspirin)" },
                {
                  sno: 10,
                  name: "T. GLYCOMET SR\n(Metformin sustained release)",
                },
                { sno: 11, name: "LUCIARA CREAM" },
                { sno: 12, name: "T. THYRONORM" },
              ].map((drug, index) => (
                <tr key={index}>
                  <td>{drug.sno}</td>
                  <td>
                    {drug.name.split("\n").map((line, idx) => (
                      <div key={idx}>
                        {line}
                        <br />
                      </div>
                    ))}
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`dosage${drug.sno + "4"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`dosage${drug.sno + "4"}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`frequency${drug.sno + "4"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`frequency${drug.sno + "4"}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`timeToTake${drug.sno + "4"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`timeToTake${drug.sno + "4"}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`days${drug.sno + "4"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`days${drug.sno + "4"}`]}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <br />
          <br />
          <div className="bulletin">
            <ul>
              <li>
                NEXT REVIEW:{" "}
                <input
                  type="date"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="nextReview4"
                  value={formData.nextReview4}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.nextReview4}
                </span>
              </li>
              <li>
                INVESTIGATIONS: Scan: Growth + Liquor -{" "}
                <input
                  type="date"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="INVESTIGATIONS4"
                  value={formData.INVESTIGATIONS4}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.INVESTIGATIONS4}
                </span>
              </li>
              <li>Blood tests: 
              <input
                  type="text"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="bloodTests4"
                  value={formData.bloodTests4}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.bloodTests4}
                </span>
              </li>
              <li>PICME NUMBER to be registered</li>
              <li>
                Fetal movements to be felt.You should feel regular perception of
                fetal movements.if fetal movements are less, lie to one side,eat
                something and then feel
              </li>
            </ul>
          </div>
          <br />
          <br />
          <div className="detail">
            <h3>
              6.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9<sup>TH</sup> MONTH
            </h3>
            <p>
              Obstetric score:{" "}
              <input
                className={`input_15 createTime ${show ? "hide" : "show"}`}
                name="obstetricScore5"
                onChange={(e) => handleChange(e, "obstetricScore5")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.obstetricScore5}
              </span>
              POG:{" "}
              <input
                className={`input_25 createTime ${show ? "hide" : "show"}`}
                name="pog5"
                onChange={(e) => handleChange(e, "pog5")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pog5}
              </span>
            </p>
            <p>
              Complaints:{" "}
              <input
                className={`input_35 createTime ${show ? "hide" : "show"}`}
                name="complaints5"
                onChange={(e) => handleChange(e, "complaints5")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.complaints5}
              </span>
            </p>
            <p>
              Blood reports:{" "}
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                style={{ border: "1px solid gray", borderRadius: "3px" }}
                name="bloodReports5"
                onChange={handleChange}
              >
                <option disabled selected>
                  Select
                </option>
                <option value="Entered">Entered</option>
                <option value="Not Entered">Not entered</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bloodReports5}
              </span>
            </p>
            <p>
              O/E: Pallor:{" "}
              <input
                className={`input_45 createTime ${show ? "hide" : "show"}`}
                name="pallor5"
                onChange={(e) => handleChange(e, "pallor5")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pallor5}
              </span>
              Pedal Edema:{" "}
              <input
                className={`input_55 createTime ${show ? "hide" : "show"}`}
                name="pedalEdema5"
                onChange={(e) => handleChange(e, "pedalEdema5")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pedalEdema5}
              </span>
            </p>
            <p>
              PR:{" "}
              <input
                className={`input_65 createTime ${show ? "hide" : "show"}`}
                name="pr5"
                onChange={(e) => handleChange(e, "pr5")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.pr5}
              </span>
              BP:{" "}
              <input
                className={`input_75 createTime ${show ? "hide" : "show"}`}
                name="bp5"
                onChange={(e) => handleChange(e, "bp5")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bp5}
              </span>
              Weight:{" "}
              <input
                className={`input_85 createTime ${show ? "hide" : "show"}`}
                name="weight5"
                onChange={(e) => handleChange(e, "weight5")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.weight5}
              </span>
              KG&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Prev visit weight:{" "}
              <input
                className={`input_95 createTime ${show ? "hide" : "show"}`}
                name="prevVisitWeight5"
                onChange={(e) => handleChange(e, "prevVisitWeight5")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.prevVisitWeight5}
              </span>
            </p>
            <p>P/A: Uterus term size, relaxed, liquor average, FHS good</p>
          </div>
          <br />
          <table className="table_1" border="1px" cellSpacing="0px">
            <tbody>
              <tr>
                <th> S.No</th>
                <th> DRUG</th>
                <th> DOSAGE</th>
                <th> FREQUENCY</th>
                <th> TIME TO TAKE</th>
                <th> DAYS</th>
              </tr>
              {[
                {
                  sno: 1,
                  name: "T. TRITOFER XT/\nFURNEXT/GLOBAC XT\n(Iron supplement)",
                },
                { sno: 2, name: "T. VEHYCAL XT\n(Calcium supplement)" },
                {
                  sno: 3,
                  name: "C. FOLVISTA/TRAFOLIC/FOLINEXT GOLD\n(Folic acid supplement)",
                },
                {
                  sno: 4,
                  name: "VIVA MOM\n(optional)\n2tsp-0-2tsp\nWITH MILK",
                },
                { sno: 5, name: "C. GESTOBOND\n(Vaginal progesterone)" },
                { sno: 8, name: "T. DYDROFIRST/DYDROBOON\n(Dydrogesterone)" },
                { sno: 10, name: "SILKY WASH" },
                {
                  sno: 11,
                  name: "CANDID CL PESSARY\n(Clindamycin+Clotrimazole)",
                },
                { sno: 12, name: "T. ECOSPIRIN\n(Aspirin)" },
                {
                  sno: 13,
                  name: "T. GLYCOMET SR\n(Metformin sustained release)",
                },
                { sno: 14, name: "LUCIARA CREAM" },
                { sno: 15, name: "T. THYRONORM" },
              ].map((drug, index) => (
                <tr key={index}>
                  <td>{drug.sno}</td>
                  <td>
                    {drug.name.split("\n").map((line, idx) => (
                      <div key={idx}>
                        {line}
                        <br />
                      </div>
                    ))}
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`dosage${drug.sno + "5"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`dosage${drug.sno + "5"}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`frequency${drug.sno + "5"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`frequency${drug.sno + "5"}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`timeToTake${drug.sno + "5"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`timeToTake${drug.sno + "5"}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name={`days${drug.sno + "5"}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`days${drug.sno + "5"}`]}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <br />
          <br />
          <div className="bulletin">
            <ul>
              <li>
                NEXT REVIEW:{" "}
                <input
                  type="date"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="nextReview5"
                  value={formData.nextReview5}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.nextReview5}
                </span>
              </li>
              <li>
                INVESTIGATIONS: Scan: Growth + Liquor -{" "}
                <input
                  type="date"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="INVESTIGATIONS5"
                  value={formData.INVESTIGATIONS5}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.INVESTIGATIONS5}
                </span>
              </li>
              <li>Blood tests: 
              <input
                  type="text"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="bloodTests5"
                  value={formData.bloodTests5}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.bloodTests5}
                </span>
              </li>
              <li>PICME NUMBER to be registered</li>
              <li>
                Fetal movements to be felt. You should feel regular perception
                of fetal movements. If fetal movements are less, lie to one side
                ,eat something and then feel
              </li>
              <li>PLAN: 
              <input
                  type="text"
                  className={`input_1 ${show ? "hide" : "show"}`}
                  name="plan5"
                  value={formData.plan5}
                  onChange={handleChange}
                />
                <span className={`span_1 ${show ? "show" : "hide"}`}>
                  {formData.plan5}
                </span>
              </li>
            </ul>
          </div>
          <br />
          <br />
          <p style={{fontWeight:"600"}}>
NEXT APPOINTMENT -{" "}
<input
name="nextappointment"
onChange={handleChange}
type="datetime-local"
// type="date"
/>
</p>
          <div className={`Footer ${show ? "hide" : "show"}`}>
            <button onClick={handlesubmit} className="Button_Create">
              Add Report
            </button>
          </div>
        </div>
      </div>
      <div id="prescriptionReport">
        <div id="prescriptionReportWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          <h1>
              1. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4<sup>TH</sup> MONTH REVIEW
          </h1>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Obstetric score :", formData.obstetricScore)}
            {renderReportfield("POG :", formData.pog)}
            {renderReportfield("Complaints :", formData.complaints)}
            {renderReportfield(
              "Double marker report :",
              formData.doubleMarkerReport
            )}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Blood reports :", formData.bloodReports)}
            {renderReportfield("O/E: Pallor :", formData.pallor)}
            {renderReportfield("Pedal Edema :", formData.pedalEdema)}
            {renderReportfield("PR", formData.pr)}
            {renderReportfield("BP", formData.bp)}
            {renderReportfield("Weight :", formData.weight)}KG
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Prev visit Weight :", formData.prevVisitWeight)}
            KG
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield(
              "P/A: Uterus 16weeks, relaxed, liquor average, FHS good"
            )}
          </div>

          <div style={{ marginBottom: "10px" }}>
            {renderReportfield("Cervical length :", formData.cervicalLength)}
            {renderReportfield(
              "Adv: Inj TD vac im stat/Option of Given 27-36 weeks"
            )}
          </div>
          <div>
            <table style={{width:"100%"}}>
              <thead>
                <tr>
                  {[
                    "S.No",
                    "DRUG",
                    "DOSAGE",
                    "FREQUENCY",
                    "TIME TO TAKE",
                    "DAYS",
                  ].map((ele) => renderTableTH(ele))}
                </tr>
              </thead>
              <tbody>
                {[
                  {
                    sno: 1,
                    name: "T.TRITOFER XT/ FURNEXT/GLOBAC XT (Iron supplement)",
                  },
                  { sno: 2, name: "C.FOLIVISTA (Folic acid supplement)" },
                  { sno: 3, name: "T.VEHYCAL (Calcium+VitD3)" },
                  { sno: 4, name: "INJ.Td VAC" },
                  { sno: 5, name: "VIVA MOM" },
                  {
                    sno: 6,
                    name: "SYP.GAVISCON (Sodium Alginate+Sodium Bicarbonate Calcium Carbonate)",
                  },
                  { sno: 7, name: "BIO OIL" },
                  { sno: 8, name: "TAB. THYRONORM (Levothyroxine)" },
                  { sno: 9, name: "TAB.GLYCOMET SR" },
                ].map((drug, index) => (
                  <tr key={index}>
                    {renderTableTD(drug.sno)}
                    <td
                      style={{ border: "1px solid black", textAlign: "center" }}
                    >
                      {drug.name.split("\n").map((line, idx) => (
                        <div key={idx}>
                          {line}
                          <br />
                        </div>
                      ))}
                    </td>

                    {renderTableTD(formData[`dosage${drug.sno}`])}

                    {renderTableTD(formData[`frequency${drug.sno}`])}

                    {renderTableTD(formData[`timeToTake${drug.sno}`])}

                    {renderTableTD(formData[`days${drug.sno}`])}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div
            style={{ display: "flex", marginBottom: "10px", marginTop: "10px" }}
          >
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("Next Review", formData.nextReview)}
            {renderReportfield(
              "INVESTIGATIONS: ANOMALY SCAN + FETAL ECHO ON",
              formData.INVESTIGATIONS
            )}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield(
              "Blood tests :",formData.bloodTests
            )}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("PICME NUMBER to be registered")}
          </div>
          <h1>
            
              2. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5<sup>TH</sup> MONTH REVIEW
           
          </h1>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Obstetric score :", formData.obstetricScore1)}
            {renderReportfield("POG :", formData.pog1)}
            {renderReportfield("Complaints :", formData.complaints1)}
            {renderReportfield(
              "Double marker report :",
              formData.doubleMarkerReport1
            )}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Blood reports :", formData.bloodReports1)}
            {renderReportfield("O/E: Pallor :", formData.pallor1)}
            {renderReportfield("Pedal Edema :", formData.pedalEdema1)}
            {renderReportfield("PR", formData.pr1)}
            {renderReportfield("BP", formData.bp1)}
            {renderReportfield("Weight :", formData.weight1)}KG
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield(
              "Prev visit Weight :",
              formData.prevVisitWeight1
            )}
            KG
            {renderReportfield("Scan Report :", formData.scanReport1)}
            {renderReportfield("Fetal Echo :", formData.fetalEcho1)}
            {renderReportfield("Tests: HB-", formData.hb1)}
          </div>

          <div style={{ display: "flex",marginBottom: "10px" }}>
            {renderReportfield("GTT :", formData.gtt1)}
            {renderReportfield("TSH :", formData.tsh1)}
            {renderReportfield("Urine C/S :", formData.urineCS1)}


          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}></div>
          <div>
            <table style={{width:"100%"}}>
              <thead>
                <tr>
                  {[
                    "S.No",
                    "DRUG",
                    "DOSAGE",
                    "FREQUENCY",
                    "TIME TO TAKE",
                    "DAYS",
                  ].map((ele) => renderTableTH(ele))}
                </tr>
              </thead>
              <tbody>
                {[
                {
                  sno: 1,
                  name: "T. TRITOFER XT/\nFURNEXT/GLOBAC XT\n(Iron supplement)",
                },
                { sno: 2, name: "T. VEHYCAL XT\n(Calcium supplement)" },
                {
                  sno: 3,
                  name: "C. FOLVISTA/TRAFOLIC/FOLINEXT GOLD\n(Folic acid supplement)",
                },
                {
                  sno: 4,
                  name: "VIVA MOM\n(optional)\n2tsp-0-2tsp\nWITH MILK",
                },
                { sno: 5, name: "C. GESTOBOND\n(Vaginal progesterone)" },
                { sno: 6, name: "T. DYDROFIRST/DYDROBOON\n(Dydrogesterone)" },
                { sno: 7, name: "SILKY WASH" },
                {
                  sno: 8,
                  name: "CANDID CL PESSARY\n(Clindamycin+Clotrimazole)",
                },
                { sno: 9, name: "T. ECOSPIRIN\n(Aspirin)" },
                {
                  sno: 10,
                  name: "T. GLYCOMET SR\n(Metformin sustained release)",
                },
                { sno: 11, name: "LUCIARA CREAM" },
                { sno: 12, name: "T. THYRONORM" },
              ].map((drug, index) => (
                  <tr key={index}>
                    {renderTableTD(drug.sno)}
                    <td
                      style={{ border: "1px solid black", textAlign: "center" }}
                    >
                      {drug.name.split("\n").map((line, idx) => (
                        <div key={idx}>
                          {line}
                          <br />
                        </div>
                      ))}
                    </td>

                    {renderTableTD(formData[`dosage${drug.sno + "1"}`])}

                    {renderTableTD(formData[`frequency${drug.sno + "1"}`])}

                    {renderTableTD(formData[`timeToTake${drug.sno + "1"}`])}

                    {renderTableTD(formData[`days${drug.sno + "1"}`])}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div
            style={{ display: "flex", marginBottom: "10px", marginTop: "10px" }}
          >
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("Next Review", formData.nextReview1)}
            {renderReportfield(
              "INVESTIGATIONS: ANOMALY SCAN + FETAL ECHO ON",
              formData.INVESTIGATIONS1
            )}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield(
              "Blood tests :",formData.Bloodtests1 
            )}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("PICME NUMBER to be registered")}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("Fetal movements to be felt.You should feel regular perception of fetal movements.")}
          </div>
          <h1>
            
              3. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 6<sup>TH</sup> MONTH SPONTANEOUS
            
          </h1>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Obstetric score :", formData.obstetricScore2)}
            {renderReportfield("POG :", formData.pog2)}
            {renderReportfield("Complaints :", formData.complaints2)}
           
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Blood reports :", formData.bloodReports2)}
            {renderReportfield("O/E: Pallor :", formData.pallor2)}
            {renderReportfield("Pedal Edema :", formData.pedalEdema2)}
            {renderReportfield("PR", formData.pr2)}
            {renderReportfield("BP", formData.bp2)}
            {renderReportfield("Weight :", formData.weight2)}KG
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield(
              "Prev visit Weight :",
              formData.prevVisitWeight2
            )}
            KG
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield(
              "P/A: Uterus 24 weeks, relaxed, liquor average, FHS good :"
            )}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}></div>
          <div>
            <table style={{width:"100%"}}>
              <thead>
                <tr>
                  {[
                    "S.No",
                    "DRUG",
                    "DOSAGE",
                    "FREQUENCY",
                    "TIME TO TAKE",
                    "DAYS",
                  ].map((ele) => renderTableTH(ele))}
                </tr>
              </thead>
              <tbody>
                {[
                {
                  sno: 1,
                  name: "T. TRITOFER XT/\nFURNEXT/GLOBAC XT\n(Iron supplement)",
                },
                { sno: 2, name: "T. VEHYCAL XT\n(Calcium supplement)" },
                {
                  sno: 3,
                  name: "C. FOLVISTA/TRAFOLIC/FOLINEXT GOLD\n(Folic acid supplement)",
                },
                {
                  sno: 4,
                  name: "VIVA MOM\n(optional)\n2tsp-0-2tsp\nWITH MILK",
                },
                { sno: 5, name: "C. GESTOBOND\n(Vaginal progesterone)" },
                { sno: 8, name: "T. DYDROFIRST/DYDROBOON\n(Dydrogesterone)" },
                { sno: 10, name: "SILKY WASH" },
                {
                  sno: 11,
                  name: "CANDID CL PESSARY\n(Clindamycin+Clotrimazole)",
                },
                { sno: 12, name: "T. ECOSPIRIN\n(Aspirin)" },
                {
                  sno: 13,
                  name: "T. GLYCOMET SR\n(Metformin sustained release)",
                },
                { sno: 14, name: "LUCIARA CREAM" },
                { sno: 15, name: "T. THYRONORM" },
              ].map((drug, index) => (
                  <tr key={index}>
                    {renderTableTD(drug.sno)}
                    <td
                      style={{ border: "1px solid black", textAlign: "center" }}
                    >
                      {drug.name.split("\n").map((line, idx) => (
                        <div key={idx}>
                          {line}
                          <br />
                        </div>
                      ))}
                    </td>

                    {renderTableTD(formData[`dosage${drug.sno + "2"}`])}

                    {renderTableTD(formData[`frequency${drug.sno + "2"}`])}

                    {renderTableTD(formData[`timeToTake${drug.sno + "2"}`])}

                    {renderTableTD(formData[`days${drug.sno + "2"}`])}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div
            style={{ display: "flex", marginBottom: "10px", marginTop: "10px" }}
          >
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("Next Review", formData.nextReview2)}
            {renderReportfield(
              "INVESTIGATIONS: ANOMALY SCAN + FETAL ECHO ON",
              formData.INVESTIGATIONS2
            )}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield(
              "Blood tests :",formData.bloodTests2
            )}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("PICME NUMBER to be registered")}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("Fetal movements to be felt.You should feel regular perception of fetal movements.if fetal movements are less,lie to one side,eat something and then feel","",{styleSec:{width:"100%"}})}
          </div>

          <h1>
           
              4. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 7<sup>TH</sup> MONTH
          
          </h1>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Obstetric score :", formData.obstetricScore3)}
            {renderReportfield("POG :", formData.pog3)}
            {renderReportfield("Complaints :", formData.complaints3)}
           
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Blood reports :", formData.bloodReports3)}
            {renderReportfield("O/E: Pallor :", formData.pallor3)}
            {renderReportfield("Pedal Edema :", formData.pedalEdema3)}
            {renderReportfield("PR", formData.pr3)}
            {renderReportfield("BP", formData.bp3)}
            {renderReportfield("Weight :", formData.weight3)}KG
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield(
              "Prev visit Weight :",
              formData.prevVisitWeight3
            )}
            KG
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield(
              "P/A: Uterus 28-30 weeks, relaxed, liquor average, FHS good :"
            )}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}></div>
          <div>
            <table style={{width:"100%"}}>
              <thead>
                <tr>
                  {[
                    "S.No",
                    "DRUG",
                    "DOSAGE",
                    "FREQUENCY",
                    "TIME TO TAKE",
                    "DAYS",
                  ].map((ele) => renderTableTH(ele))}
                </tr>
              </thead>
              <tbody>
                {[
                {
                  sno: 1,
                  name: "T. TRITOFER XT/\nFURNEXT/GLOBAC XT\n(Iron supplement)",
                },
                { sno: 2, name: "T. VEHYCAL XT\n(Calcium supplement)" },
                {
                  sno: 3,
                  name: "C. FOLVISTA/TRAFOLIC/FOLINEXT GOLD\n(Folic acid supplement)",
                },
                {
                  sno: 4,
                  name: "VIVA MOM\n(optional)\n2tsp-0-2tsp\nWITH MILK",
                },
                { sno: 5, name: "C. GESTOBOND\n(Vaginal progesterone)" },
                { sno: 8, name: "T. DYDROFIRST/DYDROBOON\n(Dydrogesterone)" },
                { sno: 10, name: "SILKY WASH" },
                {
                  sno: 11,
                  name: "CANDID CL PESSARY\n(Clindamycin+Clotrimazole)",
                },
                { sno: 12, name: "T. ECOSPIRIN\n(Aspirin)" },
                {
                  sno: 13,
                  name: "T. GLYCOMET SR\n(Metformin sustained release)",
                },
                { sno: 14, name: "LUCIARA CREAM" },
                { sno: 15, name: "T. THYRONORM" },
              ].map((drug, index) => (
                  <tr key={index}>
                    {renderTableTD(drug.sno)}
                    <td
                      style={{ border: "1px solid black", textAlign: "center" }}
                    >
                      {drug.name.split("\n").map((line, idx) => (
                        <div key={idx}>
                          {line}
                          <br />
                        </div>
                      ))}
                    </td>
                    {renderTableTD(formData[`dosage${drug.sno + "3"}`])}
                    {renderTableTD(formData[`frequency${drug.sno + "3"}`])}
                    {renderTableTD(formData[`timeToTake${drug.sno + "3"}`])}
                    {renderTableTD(formData[`days${drug.sno + "3"}`])}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div
            style={{ display: "flex", marginBottom: "10px", marginTop: "10px" }}
          >
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("Next Review", formData.nextReview3)}
            {renderReportfield(
              "INVESTIGATIONS :",
              formData.INVESTIGATIONS3
            )}
            
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield(
              "Blood tests :",formData.bloodTests3
            )}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("PICME NUMBER to be registered")}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("Fetal movements to be felt.You should feel regular perception of fetal movements.if fetal movements are less,lie to one side,eat something and then feel","",{styleSec:{width:"100%"}})}
          </div>
          <h1>
           
              5. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 8<sup>TH</sup> MONTH
           
          </h1>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Obstetric score :", formData.obstetricScore4)}
            {renderReportfield("POG :", formData.pog4)}
            {renderReportfield("Complaints :", formData.complaints4)}
           
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Blood reports :", formData.bloodReports4)}
            {renderReportfield("O/E: Pallor :", formData.pallor4)}
            {renderReportfield("Pedal Edema :", formData.pedalEdema4)}
            {renderReportfield("PR", formData.pr4)}
            {renderReportfield("BP", formData.bp4)}
            {renderReportfield("Weight :", formData.weight4)}KG
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield(
              "Prev visit Weight :",
              formData.prevVisitWeight4
            )}
            KG
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield(
              "P/A: Uterus 34 weeks, relaxed, liquor average, FHS good :"
            )}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}></div>
          <div>
            <table style={{width:"100%"}}>
              <thead>
                <tr>
                  {[
                    "S.No",
                    "DRUG",
                    "DOSAGE",
                    "FREQUENCY",
                    "TIME TO TAKE",
                    "DAYS",
                  ].map((ele) => renderTableTH(ele))}
                </tr>
              </thead>
              <tbody>
                {[
                {
                  sno: 1,
                  name: "T. TRITOFER XT/\nFURNEXT/GLOBAC XT\n(Iron supplement)",
                },
                { sno: 2, name: "T. VEHYCAL XT\n(Calcium supplement)" },
                {
                  sno: 3,
                  name: "C. FOLVISTA/TRAFOLIC/FOLINEXT GOLD\n(Folic acid supplement)",
                },
                {
                  sno: 4,
                  name: "VIVA MOM\n(optional)\n2tsp-0-2tsp\nWITH MILK",
                },
                { sno: 5, name: "C. GESTOBOND\n(Vaginal progesterone)" },
                { sno: 6, name: "T. DYDROFIRST/DYDROBOON\n(Dydrogesterone)" },
                { sno: 7, name: "SILKY WASH" },
                {
                  sno: 8,
                  name: "CANDID CL PESSARY\n(Clindamycin+Clotrimazole)",
                },
                { sno: 9, name: "T. ECOSPIRIN\n(Aspirin)" },
                {
                  sno: 10,
                  name: "T. GLYCOMET SR\n(Metformin sustained release)",
                },
                { sno: 11, name: "LUCIARA CREAM" },
                { sno: 12, name: "T. THYRONORM" },
              ].map((drug, index) => (
                  <tr key={index}>
                    {renderTableTD(drug.sno)}
                    <td
                      style={{ border: "1px solid black", textAlign: "center" }}
                    >
                      {drug.name.split("\n").map((line, idx) => (
                        <div key={idx}>
                          {line}
                          <br />
                        </div>
                      ))}
                    </td>

                    {renderTableTD(formData[`dosage${drug.sno + "4"}`])}

                    {renderTableTD(formData[`frequency${drug.sno + "4"}`])}

                    {renderTableTD(formData[`timeToTake${drug.sno + "4"}`])}

                    {renderTableTD(formData[`days${drug.sno + "4"}`])}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div
            style={{ display: "flex", marginBottom: "10px", marginTop: "10px" }}
          >
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("Next Review", formData.nextReview4)}
            {renderReportfield(
              "INVESTIGATIONS :",
              formData.INVESTIGATIONS4
            )}
            
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield(
              "Blood tests :",formData.bloodTests4
            )}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("PICME NUMBER to be registered")}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("Fetal movements to be felt.You should feel regular perception of fetal movements.if fetal movements are less,lie to one side,eat something and then feel","",{styleSec:{width:"100%"}})}
          </div>
          <h1>
         
              6. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 9<sup>TH</sup> MONTH
           
          </h1>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Obstetric score :", formData.obstetricScore5)}
            {renderReportfield("POG :", formData.pog5)}
            {renderReportfield("Complaints :", formData.complaints5)}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Blood reports :", formData.bloodReports5)}
            {renderReportfield("O/E: Pallor :", formData.pallor5)}
            {renderReportfield("Pedal Edema :", formData.pedalEdema5)}
            {renderReportfield("PR", formData.pr5)}
            {renderReportfield("BP", formData.bp5)}
            {renderReportfield("Weight :", formData.weight5)}KG
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield(
              "Prev visit Weight :",
              formData.prevVisitWeight5
            )}
            KG
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield(
              "P/A: Uterus term size, relaxed, liquor average, FHS good :"
            )}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}></div>
          <div>
            <table style={{width:"100%"}}>
              <thead>
                <tr>
                  {[
                    "S.No",
                    "DRUG",
                    "DOSAGE",
                    "FREQUENCY",
                    "TIME TO TAKE",
                    "DAYS",
                  ].map((ele) => renderTableTH(ele))}
                </tr>
              </thead>
              <tbody>
                {[
                {
                  sno: 1,
                  name: "T. TRITOFER XT/\nFURNEXT/GLOBAC XT\n(Iron supplement)",
                },
                { sno: 2, name: "T. VEHYCAL XT\n(Calcium supplement)" },
                {
                  sno: 3,
                  name: "C. FOLVISTA/TRAFOLIC/FOLINEXT GOLD\n(Folic acid supplement)",
                },
                {
                  sno: 4,
                  name: "VIVA MOM\n(optional)\n2tsp-0-2tsp\nWITH MILK",
                },
                { sno: 5, name: "C. GESTOBOND\n(Vaginal progesterone)" },
                { sno: 6, name: "T. DYDROFIRST/DYDROBOON\n(Dydrogesterone)" },
                { sno: 7, name: "SILKY WASH" },
                {
                  sno: 8,
                  name: "CANDID CL PESSARY\n(Clindamycin+Clotrimazole)",
                },
                { sno: 9, name: "T. ECOSPIRIN\n(Aspirin)" },
                {
                  sno: 10,
                  name: "T. GLYCOMET SR\n(Metformin sustained release)",
                },
                { sno: 11, name: "LUCIARA CREAM" },
                { sno: 12, name: "T. THYRONORM" },
              ].map((drug, index) => (
                  <tr key={index}>
                    {renderTableTD(drug.sno)}
                    <td
                      style={{ border: "1px solid black", textAlign: "center" }}
                    >
                      {drug.name.split("\n").map((line, idx) => (
                        <div key={idx}>
                          {line}
                          <br />
                        </div>
                      ))}
                    </td>

                    {renderTableTD(formData[`dosage${drug.sno + "5"}`])}

                    {renderTableTD(formData[`frequency${drug.sno + "5"}`])}

                    {renderTableTD(formData[`timeToTake${drug.sno + "5"}`])}

                    {renderTableTD(formData[`days${drug.sno + "5"}`])}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div
            style={{ display: "flex", marginBottom: "10px", marginTop: "10px" }}
          >
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("Next Review", formData.nextReview5)}
            {renderReportfield(
              "INVESTIGATIONS :",
              formData.INVESTIGATIONS5
            )}
            
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield(
              "Blood tests :",formData.bloodTests5
            )}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("PICME NUMBER to be registered")}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("Fetal movements to be felt.You should feel regular perception of fetal movements.if fetal movements are less,lie to one side,eat something and then feel","",{styleSec:{width:"100%"}})}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("PLAN",formData.plan5)}
          </div>
          <div style={{ marginTop: "10px" }}>
{renderReportfield("Next Appointment : ",appointmentData.date?.split("-").reverse().join("-"))}
</div>

<p class="Dani"></p>
<PrescriptionFooter/>
        </div>
      </div>
    </>
  );
}
